import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from "chart.js";
import { BarChartProps } from "../../../../@types/charts/barCharts.types";

ChartJS.register(CategoryScale, LinearScale, BarElement);

const BarChartNew: React.FC<BarChartProps> = ({ data, options }) => {
	// console.log("DATACHECK--->", data);
	// console.log("OPTIONSCHECK--->", options);
	// console.log("DATA--VALUES --->", data.datasets[0].data);

	// // console.log("DATASEToooCHECK --->", data.datasets[0].data);

	return (
		<div style={{ width: "100%", height: "100%", fontSize: "1rem" }}>
			<Bar data={data} options={options as unknown as any} />
		</div>
	);
};

export default BarChartNew;
